export enum POSSourceDTO {
    UNTILL = 'UNTILL',
}
